// src/pages/NotFound.tsx
import React from 'react';
import { Home, ArrowLeft, AlertCircle } from 'lucide-react';
import { Link } from 'react-router-dom';
export const NotFound: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-white p-4">
      <div className="max-w-2xl w-full">
        <div className="text-center">
          <div className="flex justify-center mb-8">
            <div className="relative">
              <div className="text-9xl font-extrabold text-gray-200">404</div>
              <div className="absolute inset-0 flex items-center justify-center">
                <AlertCircle className="h-24 w-24 text-red-500" />
              </div>
            </div>
          </div>
          <h1 className="text-3xl sm:text-4xl font-bold text-gray-800 mb-4">Page Not Found</h1>
          <p className="text-xl text-gray-600 mb-8">
            We're sorry, the page you requested could not be found.
          </p>
          <div className="space-y-6">
            <div className="bg-gray-50 rounded-xl p-6 border border-gray-200">
              <p className="text-gray-700 text-center">
                The page you're looking for may have been moved, deleted, or possibly never existed. 
                Please check the URL and try again.
              </p>
            </div>
            <div className="flex flex-col sm:flex-row justify-center space-y-6 sm:space-y-0 sm:space-x-6">
              <a 
                href="/" 
                className="bg-red-500 text-white px-8 py-3 rounded-md font-semibold hover:bg-red-600 transition duration-300 ease-in-out flex items-center justify-center"
              >
                <Home className="mr-2" size={20} />
                Return Home
              </a>
              <button 
                onClick={() => window.history.back()} 
                className="bg-gray-100 text-gray-800 px-8 py-3 rounded-md font-semibold hover:bg-gray-200 transition duration-300 ease-in-out flex items-center justify-center"
              >
                <ArrowLeft className="mr-2" size={20} />
                Go Back
              </button>
            </div>
          </div>
          <div className="mt-12 text-center">
            <p className="text-gray-600">
              Need assistance? {' '}
              <Link to="/support" className="text-red-500 hover:text-red-600 transition duration-300 ease-in-out font-medium">
                Contact our support team
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};